function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import { Button } from '@isyc-react/form/modules/base/button';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getTheme } from '@isyc-react/design/theme/mapper';
import { InputRadioList } from '@isyc-react/form/modules/input/option/radio';
import { blobToFile } from '@isyc-react/archives/utils';
var ExportPdfTheme = /*#__PURE__*/function (ExportPdfTheme) {
  ExportPdfTheme["STRIPED"] = "striped";
  ExportPdfTheme["GRID"] = "grid";
  ExportPdfTheme["PLAIN"] = "plain";
  return ExportPdfTheme;
}(ExportPdfTheme || {});
const exportPdfThemeOptions = [{
  checked: true,
  id: ExportPdfTheme.STRIPED
}, {
  checked: false,
  id: ExportPdfTheme.GRID
}, {
  checked: false,
  id: ExportPdfTheme.PLAIN
}];
const exportPdfThemeOptLabels = ['Striped', 'Grid', 'Plain'];
export const ExportPdf = props => {
  const {
    currentRows,
    range,
    allColumns,
    onFile
  } = props;
  const [pdfOptions, setPdfOptions] = React.useState({
    theme: exportPdfThemeOptions[0]
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "info w-100"
  }, "PDF", /*#__PURE__*/React.createElement(InputRadioList, {
    value: pdfOptions.theme,
    items: exportPdfThemeOptions,
    onChange: c => c && setPdfOptions(opt => _objectSpread(_objectSpread({}, opt), {}, {
      theme: c
    })),
    labels: exportPdfThemeOptLabels
  }), /*#__PURE__*/React.createElement(Button, {
    className: "btn btn-primary",
    onClick: () => {
      const dataRows = currentRows.filter(row => !row.isGrouped).slice(range.min, range.max).map(row => {
        const cells = [];
        // console.log('ROW: ',row)
        allColumns.forEach(col => {
          if (col.export && col.isVisible) {
            cells.push(col.export.cell(row.original));
          }
        });
        return cells;
      });
      const headers = [];
      allColumns.forEach(col => {
        if (col.export && col.isVisible) {
          headers.push(col.export.header);
        }
      });
      const theme = getTheme();
      const doc = new jsPDF();
      autoTable(doc, {
        head: [headers],
        // [['Name', 'Email', 'Country']],
        body: dataRows,
        theme: pdfOptions.theme.id || 'striped',
        // striped, grid, plain
        headStyles: {
          textColor: theme.primary.contrastText,
          fillColor: theme.primary.color
        }
        // [
        //   ['David', 'david@example.com', 'Sweden'],
        //   ['Castille', 'castille@example.com', 'Spain'],
        // ],
      });
      // doc.save('table.pdf')

      const blob = doc.output('blob');
      // TODO name prop
      const file = blobToFile(blob, 'ExportedTable.pdf', 'application/pdf');
      onFile(file);
    }
  }, "Crear PDF"));
};